
import { logger } from '@utils';
import { SagaIterator } from 'redux-saga';
import * as SubscriptionWebsocket from './subscription.websocket';

export function* subscribe(action: any): SagaIterator {
  try {
    SubscriptionWebsocket.subscribe(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 



// WEBPACK FOOTER //
// ./src/services/subscription/subscription.saga.ts